module.exports = __webpack_public_path__ + "static/media/Consciousness.93f5ab98.png";